import { useUpdateNodeInternals } from '@xyflow/react'
import { useEffect } from 'react'
import { agentLogger } from 'v2/utils/logger'
import { useTypedReactFlow } from '../../../hooks/use-react-flow'
import { highlightSingleNodeAndEdge } from '../../../run-info/utils'
import { useFlowStore } from '../../../store'
import { useEvalStore } from '../store'
import { updateEvalStatusOnNodes } from '../utils'

export const useEvalNodeHighlight = () => {
  const currentlyTestingNodeUuid = useEvalStore((state) => state.currentlyTestingNodeUuid)
  const isEvalRunning = useEvalStore((state) => state.isEvalRunning)
  const evalResults = useEvalStore((state) => state.evalResults)
  const showEvalSidebar = useFlowStore((state) => state.showEvalSidebar)
  const { fitView, setNodes } = useTypedReactFlow()
  const updateInternals = useUpdateNodeInternals()

  // Highlight currently testing node during eval run
  useEffect(() => {
    if (!currentlyTestingNodeUuid || !isEvalRunning) return

    // Highlight the currently testing node
    highlightSingleNodeAndEdge(currentlyTestingNodeUuid)

    // Center the node in view
    fitView({
      nodes: [{ id: currentlyTestingNodeUuid }],
      duration: 300,
      maxZoom: 0.9,
    })

    // Update node internals to refresh the node
    updateInternals(currentlyTestingNodeUuid)

    agentLogger.debug('Eval node highlighted and centered', {
      nodeUuid: currentlyTestingNodeUuid,
    })
  }, [currentlyTestingNodeUuid, isEvalRunning, fitView, updateInternals])

  // Apply eval status styling to nodes when sidebar is open
  useEffect(() => {
    if (!showEvalSidebar) {
      // Clear eval status from all nodes when sidebar closes
      setNodes((nodes) => updateEvalStatusOnNodes(nodes))
      return
    }

    // Apply eval status to nodes when sidebar is open
    if (evalResults.nodes.length === 0) return

    setNodes((nodes) =>
      updateEvalStatusOnNodes(nodes, evalResults.nodes, currentlyTestingNodeUuid, isEvalRunning),
    )
  }, [showEvalSidebar, evalResults.nodes, currentlyTestingNodeUuid, isEvalRunning, setNodes])

  return {
    currentlyTestingNodeUuid,
  }
}
